import { render } from "./lighting_asset_dimensions.vue?vue&type=template&id=3a07a104"
import script from "./lighting_asset_dimensions.vue?vue&type=script&lang=js"
export * from "./lighting_asset_dimensions.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__